import React from "react";
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import Icon from "../../system/components/icon";
import {useTranslate} from "../../system/useTranslate";

function RibbonButton({item, onClick, active = false}) {
    const translate = useTranslate();
    const label = translate(item.title);
    const showLabel = item.large === true;
    const iconSize = item.large ? "text-2xl" : "text-xl";
    const iconTone = active ? "text-orange-600" : (item.feature ? "text-orange-600" : "text-orange-500");
    const buttonClassName = classNames(
        "flex align-items-center justify-content-center gap-1 p-1",
        showLabel ? "px-2" : "w-2rem h-2rem",
        active || item.feature ? "bg-orange-50" : "surface-0",
    );

    return (
        <Button
            type="button"
            text
            className={buttonClassName}
            onClick={onClick}
            aria-label={label}
            aria-pressed={active}
            title={label}
            tooltip={label}
            tooltipOptions={{position: "top"}}
        >
            <Icon icon={item.icon} className={iconSize + " " + iconTone}/>
            {showLabel && (
                <span className="text-xs text-gray-800 white-space-nowrap">{label}</span>
            )}
        </Button>
    );
}

export default RibbonButton;